(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scl-03-reviews"] && !Shopify.designMode) return;
  try {
    

/* ==========================================================================
   SC LP 03 Reviews - desktop drag to scroll.

   Scoped to .scl-reviews-root so no other section is affected. Only mouse
   pointers are intercepted (e.pointerType === 'mouse'), so touch scrolling
   on mobile keeps its native behaviour. The dots, the dot-syncing scroll
   listener and the video players in the shared landing-page script are all
   left alone.
   ========================================================================== */

(function () {
  'use strict';

  function initTrack(track) {
    if (!track || track.dataset.sclDragInit === '1') return;
    track.dataset.sclDragInit = '1';

    var pointerId = null;
    var dragging = false;
    var swallowClick = false;
    var startX = 0;
    var startLeft = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;

      swallowClick = false;

      /* Nothing to drag when every card already fits. */
      if (track.scrollWidth - track.clientWidth <= 1) return;

      pointerId = e.pointerId;
      dragging = false;
      startX = e.clientX;
      startLeft = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (e) {
      if (pointerId === null || e.pointerId !== pointerId) return;

      var dx = e.clientX - startX;

      /* A few pixels of slack so a plain click on the play
         button is still a click, not a drag. */
      if (!dragging) {
        if (Math.abs(dx) < 5) return;

        dragging = true;
        track.classList.add('is-dragging');

        try { track.setPointerCapture(pointerId); } catch (err) {}
      }

      e.preventDefault();
      track.scrollLeft = startLeft - dx;
    });

    function release(e) {
      if (pointerId === null) return;
      if (e && e.pointerId !== undefined && e.pointerId !== pointerId) return;

      if (dragging) {
        try { track.releasePointerCapture(pointerId); } catch (err) {}
        track.classList.remove('is-dragging');

        /* The click that follows a drag must not start a video. */
        swallowClick = true;
      }

      pointerId = null;
      dragging = false;
    }

    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    track.addEventListener('lostpointercapture', release);

    track.addEventListener('click', function (e) {
      if (!swallowClick) return;

      swallowClick = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    /* Native image dragging would abort the gesture. */
    track.addEventListener('dragstart', function (e) {
      if (dragging) e.preventDefault();
    });
  }

  function boot(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll('.scl-reviews-root [data-scl-track]');

    Array.prototype.forEach.call(nodes, initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  /* Theme editor re-renders the section. */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();


  } catch(e) { console.error(e); }
})();
})();
